import React, { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import TextButton from 'LuxKit/Button/TextButton'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'

interface Props extends Utils.PropsWithDataAttributes {
  onClick?: () => void
  disabled?: boolean
  hideLabel?: boolean
}

const FlightSearchTravellerSelectField = React.forwardRef<
  HTMLButtonElement,
  Props
>((props, ref) => {
  const { onClick, disabled, hideLabel, ...rest } = props
  const intl = useIntl()
  const state = useContext(FlightSearchWidgetStateContext)

  const { occupants } = state

  const numberOfOccupants = occupants.adults + (occupants.children || 0) + (occupants.infants || 0)
  const label = useMemo(() => {
    if (hideLabel) return numberOfOccupants
    return intl.formatMessage(
      {
        id: 'NoRKOFxcwd',
        defaultMessage: '{count, plural, one {# Traveller} other {# Travellers}}',
        description: 'Traveller count label in flight search widget',
      },
      { count: numberOfOccupants },
    )
  }, [hideLabel, numberOfOccupants, intl])

  return (
    <TextButton
      {...rest}
      kind="tertiary"
      startIcon={<LineUserIcon />}
      endIcon={<DropdownChevron open={state.activeMenu === 'occupants'} />}
      onClick={disabled ? undefined : onClick}
      ref={ref}
      disabled={!!disabled}
    >
      {label}
    </TextButton>
  )
})

FlightSearchTravellerSelectField.displayName = 'FlightSearchTravellerSelectField'

export default FlightSearchTravellerSelectField
